/**
 * School period domain class
 */
import type {
  SchoolPeriodEntity,
} from '@/core/infrastructure/schemas/school/period/SchoolPeriodSchema'
import {
  SchoolPeriodSchema as SchoolPeriodValidationSchema
} from '@/core/infrastructure/schemas/school/period/SchoolPeriodSchema'
import type SchoolYear from '@/core/domain/school/year/SchoolYear'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator'

export default class SchoolPeriod {
  readonly schoolPeriodId: number
  readonly schoolYear: SchoolYear
  readonly schoolId: number
  readonly countStudents: number
  readonly countTeachers: number
  readonly countClassrooms: number

  constructor(period: SchoolPeriodEntity) {
    this.schoolPeriodId = period.schoolPeriodId
    this.schoolYear = period.schoolYear
    this.schoolId = period.schoolId
    this.countStudents = period.countStudents
    this.countTeachers = period.countTeachers
    this.countClassrooms = period.countClassrooms
  }

  /**
   * Crée une instance de SchoolPeriod à partir de données brutes
   */
  public static create(data: unknown): SchoolPeriod {
    return EntityValidator.validateAndCreate(
      SchoolPeriodValidationSchema,
      data,
      SchoolPeriod,
      'SchoolPeriod'
    )
  }
}

export class SchoolPeriodInput {
  readonly schoolId: number
  readonly schoolYearId: number

  constructor(schoolId: number, schoolYearId: number) {
    this.schoolId = schoolId
    this.schoolYearId = schoolYearId
  }

  /**
   * Crée une instance de SchoolPeriodInput à partir de données brutes
   */
  public static create(data: unknown): SchoolPeriodInput {
    // Pour SchoolPeriodInput, on peut créer un schéma simple ou utiliser une validation basique
    if (typeof data === 'object' && data !== null && 'schoolId' in data && 'schoolYearId' in data) {
      const typedData = data as { schoolId: number; schoolYearId: number }
      return new SchoolPeriodInput(typedData.schoolId, typedData.schoolYearId)
    }
    throw new Error('Invalid data for SchoolPeriodInput')
  }
}
